



















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ExperimentRes, DefaultExperimentRes } from "@/components/ai/types";
import CopyButton from "@/components/recommend/CopyButton.vue";

@Component({ components: { CopyButton } })

/** お試し結果ビュアー */
export default class ExperimentResViewer extends Vue {
  /** Prop */

  /** お試し結果 */
  @Prop({
    default: () => {
      DefaultExperimentRes;
    },
  })
  private experimentRes!: ExperimentRes;

  /** 利用画面 1:計画書 2:報告書 */
  @Prop({ default: 1 }) private viewType!: number;

  /** 変数 */

  /** ダイアログ制御 */
  private dialog = false;

  /** 参考情報表示フラグ */
  private showContext = true;

  /** システムプロンプト表示フラグ */
  private showSystemMessage = true;

  /** 関数 */

  /** クリップボードにコピー */
  private copy(content: string) {
    navigator.clipboard.writeText(content);
  }

  /** ダイアログ開く */
  public open() {
    this.dialog = true;
  }

  /** ダイアログ閉じる */
  public close() {
    this.dialog = false;
  }
}
